var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.526,
    height: 24.259,
    viewBox: "0 0 22.526 24.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-gift",
    "data-name": "Icon ionic-ios-gift",
    transform: "translate(-3.375 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M24.169,7.882H19.6A3.182,3.182,0,0,0,20.7,5.5,3.339,3.339,0,0,0,17.286,2.25a3.021,3.021,0,0,0-2.648,1.484A3.021,3.021,0,0,0,11.99,2.25,3.339,3.339,0,0,0,8.573,5.5a3.163,3.163,0,0,0,1.1,2.383H5.108A1.731,1.731,0,0,0,3.375,9.614V10.7a.217.217,0,0,0,.217.217H25.685A.217.217,0,0,0,25.9,10.7V9.614A1.731,1.731,0,0,0,24.169,7.882ZM17.286,3.766A1.78,1.78,0,0,1,19.111,5.5a1.78,1.78,0,0,1-1.825,1.733H15.461C15.461,4.633,16.279,3.766,17.286,3.766Zm-5.3,0c1.007,0,1.825.866,1.825,3.466H11.99A1.78,1.78,0,0,1,10.165,5.5,1.78,1.78,0,0,1,11.99,3.766Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M4.5,15.761V27.783a1.738,1.738,0,0,0,1.733,1.733h7.906V15.328H4.933A.434.434,0,0,0,4.5,15.761Z",
    transform: "translate(-0.259 -3.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M28.19,15.328H18.984V29.515H26.89a1.738,1.738,0,0,0,1.733-1.733V15.761A.434.434,0,0,0,28.19,15.328Z",
    transform: "translate(-3.588 -3.006)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.bca81e133bd4812569fe427b904c6da7.svg";
export { ForwardRef as ReactComponent };